module.exports = __webpack_public_path__ + "static/media/oliveira-hospital-3.2d01fbe9.jpg";